import { createContext, useState, useEffect } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  // 1️⃣ Fetch cart on initial load
  const fetchCart = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/cart/list`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": localStorage.getItem("token"),
          },
        }
      );
      const data = await res.json();

      // response
      if (data?.code === 200) {
        setCart(data.data || []);
      }
    } catch (err) {
      console.log("Cart fetch error", err);
    }
  };

//   useEffect(() => {
//     fetchCart();
//   }, []);
useEffect(() => {
    const token = localStorage.getItem("token");
  
    if (!token) {
      console.log("Token not available yet, skipping fetchCart");
      return;
    }
  
    fetchCart();
  }, []);
  
  return (
    <CartContext.Provider value={{ cart, fetchCart }}>{children}</CartContext.Provider>
  );
};
